import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { ImageItemModel, VectorItemModel } from '@libs/common/models';
import { BypassSecurityPipe } from '@libs/shared/ui';

@Component({
  selector: 'ui-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    BypassSecurityPipe,
  ],
})
export class ImageComponent {
  public readonly data: InputSignal<ImageItemModel | VectorItemModel> = input.required();
  public readonly objectFit: InputSignal<string> = input('cover');

  public readonly imageStyle: Signal<string> = computed(() => {
    const objectFit: string = this.objectFit();

    if (objectFit === 'contain') {
      return 'width: auto; object-fit: contain';
    }

    if (objectFit !== 'cover') {
      return 'width: auto';
    }

    const data: ImageItemModel | VectorItemModel = this.data();
    let style: string = 'object-fit: cover';

    if (data.type === 'image' && data.focalPoint) {
      style += `; object-position: ${data.focalPoint.x}% ${data.focalPoint.y}%`;
    }

    return style;
  });

  public isImageItem(item: ImageItemModel | VectorItemModel): item is ImageItemModel {
    return item.type !== 'vector';
  }

  public isVectorItem(item: ImageItemModel | VectorItemModel): item is VectorItemModel {
    return item.type === 'vector';
  }

  public getFormat(src: string): string {
    return src.slice(src.lastIndexOf('.') + 1);
  }
}
